export default __webpack_public_path__ + "static/media/battery-power-medium.811a489f.svg";